import { render, staticRenderFns } from "./CustomFieldForm.vue?vue&type=template&id=5b19f83e&scoped=true&"
import script from "./CustomFieldForm.vue?vue&type=script&lang=js&"
export * from "./CustomFieldForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomFieldForm.vue?vue&type=style&index=0&id=5b19f83e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b19f83e",
  null
  
)

export default component.exports